import {
  CONFIRMED_GET_DOCTORS,
  CONFIRMED_CREATE_DOCTOR_ACTION,
  CONFIRMED_EDIT_DOCTOR_ACTION,
  CONFIRMED_DELETE_DOCTOR_ACTION,
} from "../actions/DoctorsType";

import {
  createDoctor,
  deleteDoctor,
  formatDoctors,
  getDoctors,
  updateDoctor,
} from "../../services/DoctorsService";

import swal from "sweetalert";
import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

// Get token from Redux or fallback to localStorage
function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey;
  if (stateToken) return stateToken;

  const storedUser = localStorage.getItem("userDetails");
  return storedUser ? JSON.parse(storedUser).token : null;
}

// Get doctors list
// export function getDoctorsAction(pagination = false, pageid = 0,search_by = "", search_keyword = "",sort_by = "", sort_order = "") {
//   return async (dispatch, getState) => {
//     try {
//       const response = await getDoctors(pagination, pageid,search_by,search_keyword, sort_by, sort_order);

//       if (response?.status === 200 && response.data?.status === "success") {
//         const doctors = formatDoctors(response.data.data);
//         dispatch({ type: CONFIRMED_GET_DOCTORS, payload: doctors });
//       } else {
//         handleError("Failed to get doctors: Server error");
//       }
//     } catch (error) {
//       console.error("API Error:", error.response || error);
//       showErrorAlert("Failed to get doctors");
//     }
//   };
// }
export function getDoctorsAction(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      const response = await getDoctors(
        pagination,
        pageid,
        search_by,
        search_keyword,
        sort_by,
        sort_order,
        token
      );
      if (response?.status === 200 && response.data?.status === "success") {
        const doctors = formatDoctors(response.data.data); // Assuming formatDoctors exists
        const num_rows = response.data.num_rows; // Get num_rows from the response
        dispatch({
          type: CONFIRMED_GET_DOCTORS,
          payload: { doctors, num_rows }, // Dispatch both doctors and num_rows
        });
      } else {
        handleError("Failed to get doctors: Server error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      showErrorAlert("Failed to get doctors");
    }
  };
}

export const createDoctorAction = (doctorData) => {
  return async (dispatch) => {
    try {
      console.log("[v0] doctorData being sent:", doctorData);
      
      // Validate opening_hrs is an array
      const openingHrsArray = JSON.stringify(
        Array.isArray(doctorData.opening_hrs)
          ? doctorData.opening_hrs
          : doctorData.opening_hrs
          ? [doctorData.opening_hrs]
          : []
      );
      
      const response = await createDoctor(
        doctorData.token,
        doctorData.admin_id,
        doctorData.doctor_username,
        doctorData.doctor_password,
        doctorData.doctor_code,
        doctorData.doctor_name,
        doctorData.specialization,
        doctorData.contact_number,
        doctorData.email_address,
        doctorData.address,
        doctorData.consultation_mode,
        doctorData.consulting_duration_first_time,
        doctorData.followup_patient,
        doctorData.doctor_status,
        doctorData.doctor_type,
        openingHrsArray
      );
      

      console.log("[v0] Create doctor response:", response);

      dispatch({
        type: CONFIRMED_CREATE_DOCTOR_ACTION,
        payload: response.data?.data || response,
      });
      
      handleSuccess("Doctor added successfully!");
      return response;
    } catch (error) {
      console.error("[v0] Error in createDoctorAction:", error);
      showErrorAlert("Failed to create doctor", "error");
      throw error;
    }
  };
};

// Update Doctor Action
export const updateDoctorAction = (doctorData, doctorId) => {
  return async (dispatch) => {
    try {
      console.log("[v0] Updating doctor with data:", doctorData);
      
      // Validate opening_hrs is an array
      const openingHrsArray = JSON.stringify(
        Array.isArray(doctorData.opening_hrs)
          ? doctorData.opening_hrs
          : doctorData.opening_hrs
          ? [doctorData.opening_hrs]
          : []
      );
      

      const payload = {
        ...doctorData,
        opening_hrs: openingHrsArray,
      };

      const response = await updateDoctor(payload, doctorId);
      
      console.log("[v0] Update doctor response:", response);

      if (response) {
        dispatch({ 
          type: CONFIRMED_EDIT_DOCTOR_ACTION, 
          payload: response.data?.data || doctorData 
        });
        handleSuccess("Doctor updated successfully!");
      } else {
        showErrorAlert("Failed to update doctor", "error");
      }
      
      return response;
    } catch (error) {
      console.error("[v0] Error in updateDoctorAction:", error);
      showErrorAlert("Failed to update doctor", "error");
      throw error;
    }
  };
};
// Delete doctor
export function deleteDoctorAction(doctor_id, history) {
  return async (dispatch) => {
    try {
      await deleteDoctor(doctor_id);

      dispatch({
        type: CONFIRMED_DELETE_DOCTOR_ACTION,
        payload: { doctor_id },
      });

      if (history) history.push("/doctorpage");

      handleSuccess("Doctor deleted successfully!");
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to delete doctor");
    }
  };
}
